import { ReactMarkdownProps } from "react-markdown/lib/complex-types"
import { eventTracker } from "./google-analytics-utils"

const markdownLinkTrackerRenderer = (pageTrackinglabel: string) => {
    const MarkdownLinkTrackerRenderer = ({ href, children }: React.ClassAttributes<HTMLAnchorElement> & React.AnchorHTMLAttributes<HTMLAnchorElement> & ReactMarkdownProps) => {
        const handleLinkClick = () => {
            eventTracker(pageTrackinglabel,
                `Clicked on "${children}" link`,
                `${href}`)
        }

        return (
            <a href={href} onClick={handleLinkClick} target="_blank" rel="noreferrer">
                {children}
            </a>
        )
    }

    return MarkdownLinkTrackerRenderer
}

export default markdownLinkTrackerRenderer